/* eslint-disable no-unused-vars */
import React, { Component, useEffect, useState } from "react";

import { Row, Col, Card, CardBody, Container, Label } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PaginationNumbers from "../../components/Common/PaginationNumbers";
import api_helper, { get } from '../../helpers/api_helper'
import PageSizeSelector from "../../components/Common/PageSizeSelector";
import UserDetailCard from "../../components/Common/UserDetailCard";
import { Link } from "react-router-dom";



const UsersPage = () => {
  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { title: "Anasayfa", link: "/" },
    { title: "Kullanıcılar", link: "/users" },
  ]);

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataLimit, setDataLimit] = useState(15);

  const [filterData, setFilterData] = useState({});

  useEffect(() => {
    getData();
  }, [currentPage, dataLimit])

  const handlePageSizeChange = (newSize) => {
    setDataLimit(newSize);
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const queryParameters = `page=${currentPage}&limit=${dataLimit}`;
      const response = await get(`user/list?${queryParameters}`);
      if (!response.status === 200) {
        throw new Error('Network response was not ok.');
      }
      const data = await response.data;
      setData(data);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Firmalar" breadcrumbItems={breadcrumbItems} />
          <Row>
            <Col>
              <div className="mb-2">
                <Link to={"/new-user"} className="btn btn-success">Yeni Kullanıcı </Link>
              </div>
            </Col>
            <Col xs={12}>
              <Card>

                {isLoading && (
                  <div>Yükleniyor.</div>
                )}
                {error && (
                  <div>{error.message}.</div>
                )}
                {data && (
                  <CardBody>
                    <div className=" d-flex justify-content-between align-items-center">
                      <div className="mb-3">
                        <PageSizeSelector pageSize={dataLimit} onPageSizeChange={handlePageSizeChange}></PageSizeSelector>
                      </div>
                    </div>

                    <Row>
                      {data.records.map((data) => (
                        <Col md="6" xs="12">
                          <UserDetailCard data={data}></UserDetailCard>
                        </Col>
                      ))}
                    </Row>
                    <PaginationNumbers setCurrentPage={(e) => setCurrentPage(e)} currentPage={data.currentPage} totalPages={data.totalPages} />
                  </CardBody>
                )}

              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );

}


export default UsersPage;
